var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNaturalGas = function SvgNaturalGas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.911 17c-2.261 0-4.41-1.646-4.41-3.676a3.753 3.753 0 0 1 2.42-3.571.184.184 0 0 1 .253.187 2.36 2.36 0 0 0 .806 2.1.367.367 0 0 0 .486-.011c.647-.597 2.234-2.567-.599-5.722A.184.184 0 0 1 11.026 6c2.66.327 5.296 3.329 5.296 6.22 0 2.451-1.47 4.779-4.41 4.779Z"
  })));
};

export default SvgNaturalGas;